import { delay } from 'redux-saga';
import { select, takeLatest, put, call } from 'redux-saga/effects';

import * as action from '../../actions';
import * as exportingAction from '../../actions/exporting';
import * as actNotif from '../../actions/notifications';
import {
  GET_EXPORT_FILE,
  EXPORT_FILE,
  EXPORT_STATUS_PENDING,
  EXPORT_STATUS_SUCCESS,
  EXPORT_STATUS_FAILURE,
  EXPORT_STATUS_IN_PROGRESS,
  EXPORT_STATUS_DONE,
  SUPPLIER_EXPORT,
} from '../../actions/exporting/constants';
import {
  showExportingModal,
  getExportFile as getExportFileAction,
} from '../../actions/exporting';

import * as exportingApi from '../../api/exporting';
import { assertErrorHasMessage } from '../../utils/assert';

function* getExportStatus() {
  return yield select((state: any) => state.exporting.exportStatus);
}

function* postExportFlow(status?) {
  if (status)
    yield put(exportingAction.setExportStatus(status || EXPORT_STATUS_DONE));
  yield put(action.showLoadingSpinner(false));
}

export function* exportFile(request) {
  const { featureName, additional, outletId, asyncExport, mutexRelease } =
    request.payload;

  try {
    yield put(action.showLoadingSpinner(true));
    const payload =
      SUPPLIER_EXPORT === featureName
        ? getPayloadForExportSupplier(request.payload)
        : { feature_name: featureName, additional };

    const resExportFile = yield call(exportingApi.exportFile, payload, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      outlet_id: outletId,
    });
    const { id, status } = resExportFile.data;

    yield put(exportingAction.setExportId(id));
    yield put(exportingAction.setExportStatus(status));

    if (asyncExport) {
      const isInProgressOrSuccess = [
        EXPORT_STATUS_IN_PROGRESS,
        EXPORT_STATUS_SUCCESS,
      ].includes(yield getExportStatus());
      if (isInProgressOrSuccess) yield put(getExportFileAction(id));
      return;
    }

    let duration = 2000;
    while ((yield getExportStatus()) === EXPORT_STATUS_PENDING) {
      yield delay(duration, true);
      if ((yield getExportStatus()) === EXPORT_STATUS_PENDING)
        yield put(exportingAction.getExportFile(id));
      duration = 10000;
    }
  } catch (e) {
    assertErrorHasMessage(e);
    yield put(actNotif.error(e.message));
    yield postExportFlow();
  } finally {
    mutexRelease();
  }
}

const getPayloadForExportSupplier = ({
  additional: {
    outputFileName,
    keyword,
    business_id,
    user_email,
    is_batch_active_worker,
  },
  featureName,
}) => {
  return {
    user_email,
    feature_name: featureName,
    additional: {
      outputFileName,
      keyword,
    },
    business_id,
    is_batch_active_worker,
  };
};

export function* getExportFile(request) {
  const { id } = request.payload;

  const currentExportId = yield select(
    (state: any) => state.exporting.exportId
  );
  if (id !== currentExportId) {
    return;
  }

  try {
    const resGetExportFile = yield call(exportingApi.getExportFile, id);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { status, file_url, error_message } = resGetExportFile.data;

    if (status === EXPORT_STATUS_SUCCESS && file_url) {
      window.location.href = file_url;
      yield postExportFlow(EXPORT_STATUS_DONE);
    } else if (status === EXPORT_STATUS_FAILURE) {
      yield put(actNotif.error(error_message));
      yield postExportFlow(EXPORT_STATUS_DONE);
    } else if (!file_url && status !== EXPORT_STATUS_PENDING) {
      yield put(showExportingModal());
      yield postExportFlow();
    }
  } catch (e) {
    assertErrorHasMessage(e);
    yield put(actNotif.error(e.message));
    yield postExportFlow(EXPORT_STATUS_FAILURE);
  }
}

export default function* exportingSaga() {
  yield takeLatest(GET_EXPORT_FILE, getExportFile);
  yield takeLatest(EXPORT_FILE, exportFile);
}
